import {
  isRemoteDebugEnabled,
  recordRemoteDebug,
} from './RemoteDebugLog';

// Send logs to dev server terminal (local webpack only)
function sendToDevServer(level: string, message: string, args: unknown[]): void {
  if (typeof window === 'undefined') {
    return;
  }

  fetch('/__dev_logs__', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      level,
      message,
      args: args.map((arg) => {
        try {
          return JSON.stringify(arg);
        } catch {
          return String(arg);
        }
      }),
      timestamp: new Date().toISOString(),
    }),
  }).catch(() => {
    // Expected in production static hosting (no dev middleware)
  });
}

export function log(message: string, ...args: unknown[]): void {
  if (isRemoteDebugEnabled()) {
    recordRemoteDebug('log', message, args);
  }
  console.log(`[Courtyard] ${message}`, ...args);
  sendToDevServer('log', message, args);
}

export function logInfo(message: string, ...args: unknown[]): void {
  if (isRemoteDebugEnabled()) {
    recordRemoteDebug('info', message, args);
  }
  console.info(`[Courtyard] ${message}`, ...args);
  sendToDevServer('info', message, args);
}

export function logWarn(message: string, ...args: unknown[]): void {
  if (isRemoteDebugEnabled()) {
    recordRemoteDebug('warn', message, args);
  }
  console.warn(`[Courtyard] ${message}`, ...args);
  sendToDevServer('warn', message, args);
}

export function logError(message: string, ...args: unknown[]): void {
  if (isRemoteDebugEnabled()) {
    recordRemoteDebug('error', message, args);
  }
  console.error(`[Courtyard] ${message}`, ...args);
  sendToDevServer('error', message, args);
}
